import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import { get, isEmpty } from 'lodash';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import {
  clearApiErrorResponseAction,
  fetchSocialMediaCampaignDetailsAction,
  clearSocialMediaCampaignDetailsAction,
  trackCustomerAggregationAction,
} from '../../../actions/common';
import { sendOtpAction, attemptLoginAction } from '../../../actions/app.action';
import { fetchRewardGuestDetailsAction, dispatchCallbackUrlAction } from '../../../actions/rewards';

const Signup = asyncRoute(() => import('../components/Signup'));
const CampaignDetail = asyncRoute(() => import('../components/CampaignDetail'));

const Instagram = (props) => {
  const location = get(props, 'location', {});
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const view = get(queryParams, 'view', '');
  const campaignCode = get(queryParams, 'campaignCode', '');
  const brandId = get(queryParams, 'brandId', '');
  const utm = get(queryParams, 'utm', '');
  const userId = get(queryParams, 'userId', '');

  useEffect(() => {
    // if (brandId && campaignCode) {
    //   const trackingData = {
    //     brandId,
    //     externalUserId: userId,
    //     externalSource: 'IG',
    //     campaignCode,
    //     actionType: 'OFFER_LINK_CLICK',
    //     utm,
    //   };
    //   props.actions.trackCustomerAggregation({ trackingData });
    // }
    return () => {
      props.actions.clearSocialMediaCampaignDetails();
    };
  }, []);

  useEffect(() => {
    const url = `code/${campaignCode}?brandId=${brandId}`;
    props.actions.fetchSocialMediaCampaignDetails({ url });
  }, [campaignCode, brandId]);

  const renderComponentByView = (view) => {
    switch (view) {
      case 'pre-signin':
        return <Signup {...props} />;
      case 'post-signin':
        return <CampaignDetail {...props} />;
      default:
        return <Signup {...props} />;
    }
  };

  return <>{!isEmpty(props.socialMediaCampaignDetails) && renderComponentByView(view)}</>;
};

const mapStateToProps = (state) => ({
  socialMediaCampaignDetails: get(state, 'common.socialMediaCampaignDetails', {}),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      sendOtp: sendOtpAction,
      attemptLogin: attemptLoginAction,
      clearApiErrorResponse: clearApiErrorResponseAction,
      dispatchCallbackUrl: dispatchCallbackUrlAction,
      fetchRewardGuestDetails: fetchRewardGuestDetailsAction,
      fetchSocialMediaCampaignDetails: fetchSocialMediaCampaignDetailsAction,
      clearSocialMediaCampaignDetails: clearSocialMediaCampaignDetailsAction,
      trackCustomerAggregation: trackCustomerAggregationAction,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Instagram);
